import { matchPath, useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

type ReturnType = {
  active: boolean;
  isExternalLink: boolean;
};

export default function useActiveLink(
  path: string,
  deep = true,
  activeForPaths?: string[],
): ReturnType {
  const { pathname } = useLocation();

  // Strip query parameters from path for matching
  const pathWithoutQuery = path ? path.split('?')[0] : '';

  const normalActive = pathWithoutQuery
    ? !!matchPath({ path: pathWithoutQuery, end: true }, pathname)
    : false;

  const forPathsActive =
    pathWithoutQuery && activeForPaths
      ? [pathWithoutQuery, ...activeForPaths]
          .map((_path) => !!matchPath({ path: _path, end: true }, pathname))
          .some((active) => !!active)
      : false;

  const deepActive = pathWithoutQuery
    ? !!matchPath({ path: pathWithoutQuery, end: false }, pathname)
    : false;

  return {
    active: deep ? deepActive || forPathsActive : normalActive,
    isExternalLink: path.includes('http'),
  };
}
